module.exports = __webpack_public_path__ + "img/icon-marker-outline.4e7a1126.svg";